import { Project } from "./project";

export enum UserRole {
  Admin = "admin",
  Creator = "creator",
  Actor = "actor",
  Coach = "coach",
}

export enum CalendarProvider {
  Outlook = "outlook",
  Google = "google",
}

export interface CalendarConnection {
  provider: CalendarProvider;
  calendarId: string;
  accountUsername?: string;
  connectedAt?: Date;
  includePrivateEvents?: boolean;
}

export interface ApiUser {
  id?: string;
  email: string;
  role: UserRole;
  projects?: Project[];
  invitedUserEmails?: string[];
  termsAcceptanceDate?: Date;
  firstName?: string;
  lastName?: string;
  organization?: string;
  createdBy?: string;
  comments?: string;
  createdDate?: Date;
  updatedDate?: Date;
  emailSuggestions?: Array<{ value: string; count: number }>;
  categorySuggestions?: Array<{ value: string; count: number }>;
  calendarConnections?: CalendarConnection[];
}
